import type { AxiosInstance } from 'axios';
import { injectable } from 'inversify';
import { PitchComTriggerType } from 'pages/Home/components/PitchComModal/PitchComModal';
import { ConfigurationService } from 'services/ConfigurationService';
import { Result } from 'services/Result';

@injectable()
export class PitchComService {
  private axiosInstance: AxiosInstance;

  private configurationService: ConfigurationService;

  constructor(axiosInstance: AxiosInstance, configurationService: ConfigurationService) {
    this.axiosInstance = axiosInstance;
    this.configurationService = configurationService;
  }

  async sendTestRequest(type: PitchComTriggerType) {
    const response = await this.axiosInstance.get<Result<{ success: boolean; errorMessage: string }>>(`api/pitchcom/${type}`);

    if (response && response.data && !response.data.isError && response.data.data) {
      return response.data.data;
    } else if (response && response.data && response.data.errorMessage) {
      return {
        success: false,
        errorMessage: response.data.errorMessage,
      };
    } else {
      return {
        success: false,
        errorMessage: 'Failed to connect with device',
      };
    }
  }
}
